import React from 'react'
import { RecordingList } from '@Entities/matching/recording-group-details'
import { RecordingModel } from '@Entities/work/recording-model'

interface WorkItemRecordingsProps {
    draftType: boolean | undefined
    recordings: RecordingModel[]
    matchedRecordings: RecordingList | null
}

const WorkItemRecordings = (props: WorkItemRecordingsProps) => {
    const { draftType, recordings, matchedRecordings } = props
    const recordingsToUse = draftType ? recordings : matchedRecordings
    const recordingsCount = draftType ? recordings.length : matchedRecordings?.count
    const recordingsTitle = draftType
        ? recordings?.length && recordings[0]?.title
        : matchedRecordings?.recordings?.length && matchedRecordings.recordings[0]?.recordingTitle
    const artistTitle = draftType
        ? recordings?.length && recordings[0]?.artistName
        : matchedRecordings?.recordings?.length && matchedRecordings.recordings[0]?.recordingDisplayArtistName

    return (
        <>
            <div>
                <p className="small-2">Recordings ({recordingsToUse && recordingsCount ? recordingsCount : 0})</p>
                {recordingsToUse && recordingsCount ? <p className="small-2 bold">{recordingsTitle}</p> : null}
            </div>
            <div>
                <p className="small-2">Artists ({recordingsToUse && recordingsCount ? recordingsCount : 0})</p>
                {recordingsToUse && recordingsCount ? <p className="small-2 bold">{artistTitle}</p> : null}
            </div>
        </>
    )
}
export default WorkItemRecordings
